import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import i18n from 'i18next';
import { Home, ShoppingBag, Search, User, Grid } from 'react-feather';

// Утасны доод navigation (mockup-ын Home · Shop · Search · Account · Cart).
// Wishlist backend байхгүй тул оронд нь Хайлт.
const MobileTabBar = () => {
    const router = useRouter();
    const system = useSelector((state) => state.system);
    const auth = useSelector((state) => state.auth);
    const isEn = i18n.language !== 'mn';

    const shopHref = system.categories?.[0]?.id
        ? `/products/${system.categories[0].id}`
        : '/';
    const basketCount = auth?.account?.accountInfo?.basketCount || 0;

    const tabs = [
        {
            href: '/',
            mn: i18n.t('title.home'),
            en: i18n.t('title.home'),
            Icon: Home,
            match: (p) => p === '/',
        },
        {
            href: shopHref,
            mn: i18n.t('title.product'),
            en: i18n.t('title.product'),
            Icon: Grid,
            match: (p) => p.startsWith('/products'),
        },
        {
            href: '/search',
            mn: i18n.t('button.search'),
            en: i18n.t('button.search'),
            Icon: Search,
            match: (p) => p.startsWith('/search'),
        },
        {
            href: auth?.accountLoggedIn ? '/profile' : '/login',
            mn: auth?.accountLoggedIn
                ? i18n.t('title.profile')
                : i18n.t('title.login'),
            en: auth?.accountLoggedIn
                ? i18n.t('title.profile')
                : i18n.t('title.login'),
            Icon: User,
            match: (p) =>
                p.startsWith('/profile') ||
                p.startsWith('/login') ||
                p.startsWith('/orders'),
        },
        {
            href: '/basket',
            mn: i18n.t('title.basket'),
            en: i18n.t('title.basket'),
            Icon: ShoppingBag,
            match: (p) => p.startsWith('/basket'),
            badge: basketCount,
        },
    ];
    const path = router.asPath.split('?')[0];

    return (
        <nav
            aria-label="Mobile navigation"
            className="md:hidden fixed bottom-0 inset-x-0 z-[40] bg-ink text-paper border-t border-paper/10"
            style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
        >
            <ul className="grid grid-cols-5">
                {tabs.map(({ href, mn, en, Icon, match, badge }) => {
                    const active = match(path);
                    return (
                        <li key={en}>
                            <Link
                                href={href}
                                className={`relative flex flex-col items-center justify-center gap-1 h-14 text-[10px] tracking-wide transition-colors ${
                                    active
                                        ? 'text-paper'
                                        : 'text-paper/60 hover:text-paper'
                                }`}
                            >
                                <Icon size={18} />
                                {isEn ? en : mn}
                                {badge > 0 ? (
                                    <span className="absolute top-1.5 right-[calc(50%-18px)] min-w-[16px] h-4 px-1 rounded-full bg-paper text-ink text-[10px] leading-4 text-center">
                                        {badge}
                                    </span>
                                ) : null}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default MobileTabBar;
